import { z } from 'zod';
/**
 * Voice provider rate table — published to SSM at /cloneai/<env>/voice-rates
 * as a JSON parameter. Updated out-of-band via `aws ssm put-parameter`;
 * no deploy needed. Phase-2 readers cache per Lambda cold start.
 *
 * Keys are `${voiceProvider}/${model}`. The wildcard `${voiceProvider}/default`
 * acts as the fallback when a model-specific entry is missing.
 *
 * Costs are USD. Token rates are USD per million tokens. Per-minute rates
 * (Vapi) are USD per call-minute.
 */
const TokenRatesSchema = z.object({
    inputTextPerMillion: z.number().nonnegative(),
    inputTextCachedPerMillion: z.number().nonnegative(),
    inputAudioPerMillion: z.number().nonnegative(),
    inputAudioCachedPerMillion: z.number().nonnegative(),
    outputTextPerMillion: z.number().nonnegative(),
    outputAudioPerMillion: z.number().nonnegative(),
});
const PerMinuteRatesSchema = z.object({
    perMinuteUsd: z.number().nonnegative(),
});
export const VoiceProviderRateSchema = z.union([TokenRatesSchema, PerMinuteRatesSchema]);
export const VoiceRatesTableSchema = z.record(z.string(), VoiceProviderRateSchema);
//# sourceMappingURL=voiceRates.js.map